import SoftballPitchType from './SoftballPitchType.js';
import BaseballPitchType from './BaseballPitchType.js';

const PitchType = Object.assign({} ,BaseballPitchType, SoftballPitchType );

export default PitchType;